import { RegularExpressions } from "../Helpers/RegularExpression";

export const ValFormReg = (
  prop,
  value,
  expression,
  minLength = 0,
  MaxLength = 0
) => {
  var isValid = true;
  var mensaje = "";
  var rValue = value;

  if (value === undefined || value === null || value === "") {
    mensaje = `El campo <b>${prop}</b> es un valor requerido  <br>`;
    isValid = false;
    rValue = "";
  } else {
    if (!expression.test(value)) {
      isValid = false;
      switch (expression) {
        case RegularExpressions.TextWithSpace: {
          mensaje = `El campo <b>${prop}</b> solo puede contener letras y espacios <br>`;
          break;
        }
        case RegularExpressions.TextEmail: {
          mensaje = `El campo <b>${prop}</b> no corresponde a un correo electronico valido <br>`;
          break;
        }
        case RegularExpressions.TextOnlyNumber: {
          mensaje = `El campo <b>${prop}</b> solo puede contener numeros <br>`;
          break;
        }
        case RegularExpressions.TextAndNumber: {
          mensaje = `El campo <b>${prop}</b> no corresponde a un numero de telefono valido <br>`;
          break;
        }
        case RegularExpressions.TextAndNumber: {
          mensaje = `El campo <b>${prop}<b> solo puede contener letras, espacios y numeros <br>`;
          break;
        }
      }
    } else if (
      Number(minLength) > 0 &&
      Number(minLength) === Number(MaxLength) &&
      Number(minLength) !== Number(value.length)
    ) {
      isValid = false;
      mensaje = `El campo <b>${prop}</b> debe estar formado por ${minLength} caracteres  <br>`;
    } else if (
      Number(minLength) > 0 &&
      Number(minLength) > Number(value.length)
    ) {
      isValid = false;
      mensaje = `El campo <b>${prop}</b> debe contener por lo menos ${minLength} caracteres  <br>`;
    } else if (
      Number(MaxLength) > 0 &&
      Number(MaxLength) < Number(value.length)
    ) {
      isValid = false;
      mensaje = `El campo <b>${prop}</b> debe contener como maximo ${MaxLength} caracteres  <br>`;
    }
  }
  return { isValid, mensaje, rValue };
};

export const ValForm = (prop, value) => {
  var isValid = true;
  var mensaje = "";
  var rValue = value;
  if (value === undefined || value === undefined || value === "") {
    mensaje = `El campo <b>${prop}</b> es un valor requerido <br>`;
    isValid = false;
    rValue = "";
  }

  return { isValid, mensaje, rValue };
};
